import styled from "@emotion/styled/macro";
import { Link } from "react-router-dom";
import headerMobile from "../../assets/images/accidentHeaderMobile.png";
import header from "../../assets/images/accidentHeader.png";
import { BodyContentLayout } from "../../components/ui/ContentLayout";
import CardPart from "../../components/pageParts/CardPart";
import { useTranslation, Trans } from "react-i18next";
import FaqPart from "../Faq/FaqPart";
import PageHeader from "../../components/pageParts/PageHeader";
import bullet from "../../assets/images/bullet.svg";
import { Divider } from "@chakra-ui/react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${({ theme }) => theme.colors.white};
`;
const WhiteContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 3em 2em;
  }
  display: flex;
  flex-direction: column;
  padding: 0;
  line-height: 1.5em;
`;

const Subtitle = styled.h2`
  border-top: 1px solid ${({ theme }) => theme.colors.opal};
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.6em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
`;

const Subsubtitle = styled.h3`
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.4em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
`;
const Text = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.primary};
  & a {
    text-decoration: underline;
  }
`;

const Wrapper = styled.div`
  display: flex;
`;
const Parts = styled.div`
  padding-bottom: 4em;
`;
const SubPart = styled.div`
  padding-top: 2em;
`;
const Details = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 4em;
    display: flex;
    flex-direction: column;
    width: fit-content;
  }
`;
const NavMenu = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 35%;
    flex-direction: column;
    display: flex;
  }
`;
const Bullets = styled.ul`
  padding-left: 2em;
  list-style: outside url(${bullet});
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  li {
    padding: 0.5em 0;
  }
`;
const StyledDivider = styled(Divider)`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    border-color: ${({ theme }) => theme.colors.secondary};
    margin-bottom: 4em;
  }
`;
const MenuItem = styled.li`
  list-style: none;
  cursor: pointer;
  padding-bottom: 1em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: 1em;
    border-bottom: 1px solid ${({ theme }) => theme.colors.opal};
  }
`;

const Accident = () => {
  const { t } = useTranslation();
  const scroll = (scrollTo) => {
    document.querySelector(`#${scrollTo}`)?.scrollIntoView({
      behavior: "smooth",
    });
  };
  const cards = ["insurance", "abroad", "verification"];
  return (
    <Container>
      <PageHeader title={t("accident.title")} text={t("accident.info")} background={header} imgMobile={headerMobile} />
      <WhiteContainer>
        <BodyContentLayout>
          <Wrapper>
            <NavMenu>
              <ul>
                <MenuItem onClick={() => scroll("intro")}>{t("accident.intro")}</MenuItem>
                <MenuItem onClick={() => scroll("belgeTitle")}>{t("accident.belgeTitle")}</MenuItem>
                <MenuItem onClick={() => scroll("foreign")}>{t("accident.foreignTitle")}</MenuItem>
              </ul>
            </NavMenu>
            <Details>
              <Parts id="intro">
                <Subtitle>{t("accident.intro")}</Subtitle>
                <Text>
                  <Trans i18nKey="accident.introText">
                    phase. <br />
                    <br /> if accident <br /> convenient right <br /> <br />
                    form. <br /> <br /> please
                  </Trans>
                </Text>
              </Parts>
              <StyledDivider />
              <Parts id="belgeTitle">
                <Subtitle>{t("accident.belgeTitle")}</Subtitle>
                <Subsubtitle>{t("accident.insuranceConfirmedSubtitle")}</Subsubtitle>
                <Text>
                  <Trans i18nKey="accident.insuranceConfirmedText">
                    card? <br />
                    <br /> it is
                  </Trans>
                </Text>
                <SubPart>
                  <Subsubtitle>{t("accident.insuranceNotConfirmedSubtitle")}</Subsubtitle>
                  <Bullets>
                    <li>{t("accident.insuranceBulletOne")}</li>
                    <li>{t("accident.insuranceBulletTwo")}</li>
                    <li>{t("accident.insuranceBulletThree")}</li>
                  </Bullets>
                </SubPart>
              </Parts>
              <StyledDivider />
              <Parts id="foreign">
                <Subtitle>{t("accident.foreignTitle")}</Subtitle>
                <Text>
                  <Trans i18nKey="accident.foreignText">
                    form. <br /> <br /> all check. <br /> <br /> the belgian
                    <Link target="_blank" to={{ pathname: "http://www.cobx.org" }}>
                      {""}
                    </Link>
                  </Trans>
                </Text>
              </Parts>
            </Details>
          </Wrapper>
        </BodyContentLayout>
      </WhiteContainer>
      <CardPart cards={cards} />
      <FaqPart topic={t("header.menu.accident")} />
    </Container>
  );
};

export default Accident;
